export default __webpack_public_path__ + "static/media/10D.7ae9eea7.png";